import { render, staticRenderFns } from "./vue-file-base64.vue?vue&type=template&id=69d84f87&"
import script from "./vue-file-base64.vue?vue&type=script&lang=js&"
export * from "./vue-file-base64.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports